import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-3 mt-lg-4 mb-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("myCadac.accountSettings.company.relatedContacts")), 1),
    _hoisted_2,
    (_ctx.items.length)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          "auto-layout": "",
          paginator: _ctx.showPagination,
          "removable-sort": "",
          "responsive-layout": "stack",
          rows: _ctx.maxRowsToShow,
          value: _ctx.items
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              key: "firstName",
              field: "firstName",
              header: _ctx.$t('myCadac.accountSettings.company.table.lblFirstName'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(item.data.firstName), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "lastName",
              field: "lastName",
              header: _ctx.$t('myCadac.accountSettings.company.table.lblLastName'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(item.data.lastName), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "email",
              field: "email",
              header: _ctx.$t('myCadac.accountSettings.company.table.lblEmail')
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(item.data.email), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { key: "edit" }, {
              body: _withCtx((item) => [
                (_ctx.canEdit)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-icon p-button-rounded p-button-text p-button-raised",
                      icon: "pi pi-pencil",
                      label: _ctx.isSmallScreen ? _ctx.$t('myCadac.accountSettings.company.table.lblEditButton') : '',
                      title: _ctx.$t('myCadac.accountSettings.company.table.lblEditButton'),
                      onClick: ($event: any) => (_ctx.onEditClick(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["paginator", "rows", "value"]))
      : _createCommentVNode("", true)
  ], 64))
}